var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.viewTemplate === "default"
        ? [
            _c(
              "nav",
              {
                staticClass:
                  "navbar navbar-expand-md navbar-dark bg-dark fixed-top",
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "sanitizedHref",
                          rawName: "v-sanitizedHref",
                          value: _vm.dashboardUrl,
                          expression: "dashboardUrl",
                        },
                      ],
                      staticClass: "btn btn-light mr-auto",
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-angle-double-left",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        "\n                    My Survey\n                "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "container",
                staticStyle: { "padding-top": "80px" },
              },
              [
                _c(
                  "div",
                  { attrs: { id: "MeetingQuestion" } },
                  [
                    _c("MeetingQuestionReview", {
                      attrs: {
                        propIsMeetingManager: false,
                        propRm: _vm.question,
                      },
                      on: {
                        "update-vote-value": _vm.handleSavePanelistVoteCommand,
                        "update-vote-comment":
                          _vm.handleSavePanelistVoteCommentCommand,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.viewTemplate === "connecting" ? [_vm._m(0)] : _vm._e(),
      _vm._v(" "),
      _vm.viewTemplate === "notStarted"
        ? [
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-center",
                staticStyle: { "padding-top": "200px" },
              },
              [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("h5", { staticClass: "card-title" }, [
                      _vm._v("Meeting is not started"),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "card-text lead" }, [
                      _vm._v("Please wait for the host to start this meeting."),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _vm.surveyStarted
                      ? _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: _vm.dashboardUrl,
                                expression: "dashboardUrl",
                              },
                            ],
                            staticClass: "btn btn-secondary",
                          },
                          [_vm._v("Go to the survey")]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "d-flex justify-content-center",
        staticStyle: { "padding-top": "200px" },
      },
      [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h5", { staticClass: "card-title" }, [
              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
              _vm._v(" Connecting..."),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "card-text lead" }, [
              _vm._v("We are checking if meeting was started by the host."),
            ]),
            _c("br"),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }